"use strict";
/*
 * Created on 2019-07-15
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author JMr
 */


var CompetitorPriceChangeReportRequestConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorPriceChangeReportRequestConverter, _DataObjectConverter_);

  function CompetitorPriceChangeReportRequestConverter() {
    _classCallCheck(this, CompetitorPriceChangeReportRequestConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceChangeReportRequestConverter).apply(this, arguments));
  }

  return CompetitorPriceChangeReportRequestConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorPriceChangeReportRequestConverter = CompetitorPriceChangeReportRequestConverter;